import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AlertService} from '../../../common/alert-service/alert.service';
import {ProductionArticleService} from './production-article.service';
import {Article} from '../models/article.models';
import {ArticleProductionStepView} from '../../../envisia/article/production/production.models';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'article-production-edit',
    templateUrl: './article-production-edit.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArticleProductionEditComponent implements OnInit {
  @Input() article: Article;
  @Input() data: ArticleProductionStepView;

  errors?: { [key: string]: string; } = {};
  editForm: UntypedFormGroup;
  submitLocked = false;

  constructor(private modalRef: NgbActiveModal,
              private modalService: NgbModal,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private productionArticleService: ProductionArticleService) {
  }

  ngOnInit(): void {
    this.editForm = this.fb.group({
      infoText: [this.data.article.infoText],
      lockText: [this.data.article.lockText],
    });
  }

  submit() {
    this.errors = {};
    this.submitLocked = true;
    this.productionArticleService.edit(
      this.article.oa_nr,
      this.data.article.ordering,
      this.editForm.value,
    ).subscribe(() => {
      this.alertService.add('success', 'Fertigungsschritt wurde erfolgreich editiert!');
      this.modalRef.close();
    }, response => {
      this.submitLocked = false;
      if (response.error) {
        this.errors = response.error;
      }
      this.alertService.add('danger', 'Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut ' +
        'oder benachrichtigen Sie Ihren Administrator!');
    });
  }

  dismiss() {
    this.modalRef.dismiss();
  }

}
